export enum SessionState {
  VALID = 'VALID',
  TWO_FACTOR_AUTHENTICATION = 'TWO_FACTOR_AUTHENTICATION',
  INVALIDATED = 'INVALIDATED',
  EXPIRED = 'EXPIRED',
}
